import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";

// import constant
import constant from "lib/constant/constant";

import OperatorReporting from "./operator/reporting";
import ProviderReporting from "./provider/reporting";

const { userKey } = constant;
const { operator, provider } = userKey;

const Reporting = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorReporting />;
    }
    if (role === provider) {
      return <ProviderReporting />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const ReportingComponent = getComponent(currentUserRole);
  return ReportingComponent;
};

export default Reporting;
